import { Icon } from "semantic-ui-react";
import { Tooltip } from "../tooltip";
import { TextTruncate } from "components/textTruncators/TextTruncators";
import { BaseLabel, type BaseLabelProps } from "../BaseLabel/BaseLabel";

interface Props extends BaseLabelProps {
  text: string;
  icon?: string;
}

export const Label = (props: Props) => {
  const { text, icon, color, className, basic, attached } = props;
  return (
    <BaseLabel color={color} className={className} basic={basic} attached={attached}>
      <Tooltip
        target={
          <TextTruncate>
            {icon && <Icon className={icon} />} {text}
          </TextTruncate>
        }
        content={text}
      />
    </BaseLabel>
  );
};
